// 세션 첫 방문의 유입 정보(UTM·referrer·랜딩 경로·AI 답변 엔진 출처)를 저장해 두었다가 문의 폼 제출 때 함께 보낸다.
// 답변 엔진(ChatGPT·Perplexity 등)에서 온 첫 방문은 GA4 ai_referral 이벤트로도 남긴다(AEO·GEO 측정).
import { detectAiSource } from './aiReferral';
import { trackEvent } from './analytics';

const STORAGE_KEY = 'dgm_attribution';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

const readStorage = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
  } catch (e) {
    return null;
  }
};

export const captureAttribution = () => {
  if (typeof window === 'undefined' || readStorage()) return;

  const params = new URLSearchParams(window.location.search);
  const attribution = {
    landing_page: window.location.pathname,
    referrer: document.referrer || '',
    first_visit_at: new Date().toISOString(),
  };
  UTM_KEYS.forEach((key) => {
    attribution[key] = params.get(key) || '';
  });
  attribution.ai_source = detectAiSource(attribution.referrer, attribution.utm_source);
  if (attribution.ai_source) {
    trackEvent('ai_referral', { ai_source: attribution.ai_source, landing_page: attribution.landing_page });
  }

  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
  } catch (e) {
    // 저장소를 쓸 수 없는 브라우저(사생활 보호 모드 등)에서는 기록하지 않는다.
  }
};

export const getAttribution = () => {
  if (typeof window === 'undefined') return {};
  return readStorage() || {};
};
